import { DealItemWithVersions } from '@/lib/graphql/generated/graphql';

/** Catégorisation AI (ou équivalent) en cours pour cette ligne. */
export function isDealItemCategoryUpdating(
  item: DealItemWithVersions
): boolean {
  return (
    item.activeVersion.updatingFields?.includes('productCategory') ?? false
  );
}

/** Résout un deal item par `dealItem.id` ou `activeVersion.id`. */
export function findDealItemByVersionOrItemId(
  products: DealItemWithVersions[],
  id: string
): DealItemWithVersions | undefined {
  return products.find((p) => p.id === id || p.activeVersion?.id === id);
}

/** Dernière version connue du deal item dans la map, sinon le snapshot fourni. */
export function resolveDealItemFromMap(
  productsMap: Map<string, DealItemWithVersions>,
  item: DealItemWithVersions
): DealItemWithVersions {
  return productsMap.get(item.id) ?? item;
}

/**
 * Ajoute ou retire un champ de `updatingFields` pour les items ciblés.
 * Utilisé comme updater pur pour productsMapState.
 */
export function toggleUpdatingField(
  prev: Map<string, DealItemWithVersions>,
  idsSet: Set<string>,
  field: string,
  add: boolean
): Map<string, DealItemWithVersions> {
  if (idsSet.size === 0) return prev;
  const next = new Map(prev);
  for (const id of idsSet) {
    const item = prev.get(id);
    if (!item) continue;
    const current = item.activeVersion.updatingFields ?? [];
    const hasField = current.includes(field);
    if (add ? hasField : !hasField) continue;
    const updated = add
      ? [...current, field]
      : current.filter((f) => f !== field);
    next.set(id, {
      ...item,
      activeVersion: { ...item.activeVersion, updatingFields: updated },
    });
  }
  return next;
}
